export default __webpack_public_path__ + "static/media/IheartRadio.145b8f98.svg";